<script>
export default {
  computed: {
    hasAvailabilityStatusOnlyPermission() {
      return this.$fischer.shop.hasAvailabilityStatusOnlyPermission();
    },
  },
  methods: {
    getPrivileges(
      sitecorePrivileges,
      customerPrivileges,
      withLabel,
      ignoreMandatory,
      noShopAccess,
    ) {
      if (!sitecorePrivileges) {
        return null;
      }

      if (withLabel) {
        return sitecorePrivileges.map((el) => ({
          headline: el.headline,
          privileges: this.loopPrivileges(
            el.privileges,
            customerPrivileges,
            ignoreMandatory,
            noShopAccess,
          ),
        }));
      }

      return this.loopPrivileges(
        sitecorePrivileges,
        customerPrivileges,
        ignoreMandatory,
        noShopAccess,
      );
    },
    loopPrivileges(
      privilegesData,
      customerPrivileges,
      ignoreMandatory,
      noShopAccess,
      parentSelected,
    ) {
      if (!privilegesData) {
        return null;
      }

      return privilegesData.map((accessPrivilege) => {
        const mandatory = !ignoreMandatory && accessPrivilege.Mandatory;
        let selected = mandatory;
        let disabled = parentSelected || mandatory;

        // disable shop privilege if not authorized
        if (!accessPrivilege.Global && noShopAccess) {
          selected = false;
          disabled = true;
        }

        if (!mandatory && customerPrivileges) {
          selected = customerPrivileges.some(
            (userAccessPrivilege) => accessPrivilege.Value === userAccessPrivilege.uid,
          );
        }

        return {
          name: accessPrivilege.Title,
          value: accessPrivilege.Value,
          disabled: disabled,
          selected,
          subGroups: this.loopPrivileges(
            accessPrivilege.Subgroups,
            customerPrivileges,
            ignoreMandatory,
            noShopAccess,
            selected,
          ),
        };
      });
    },
    hasActivePrivilege(privileges) {
      if (!privileges) {
        return false;
      }

      return privileges.some((item) => item.selected || this.hasActivePrivilege(item.subGroups));
    },
  },
};
</script>
